import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { emit } from './event-emitter';
import Dropdown from './dropdown';
import { OPEN_DROPDOWN } from './const';

function DropdownTrigger({
  for: labelFor = null,
  arrow = false,
  children = null,
  className = '',
  ...otherProps
}) {
  const triggerClass = classnames(
    'ws-dropdown__trigger',
    {
      'ws-dropdown__trigger-arrow': arrow,
    },
    className
  );

  const onClick = () => {
    Dropdown.dispatchHide();
    emit(OPEN_DROPDOWN, labelFor);
  };

  return (
    <a {...otherProps} {...(labelFor && { onClick })} className={triggerClass}>
      {children}
    </a>
  );
}

DropdownTrigger.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  for: PropTypes.string,
  arrow: PropTypes.bool,
};

export default DropdownTrigger;
